export const addRecentSearch = (data,next) => {
    /*   alert(data); */
    /* console.log(data) */
      if (typeof window !== 'undefined' ) {
          localStorage.setItem("recentSearch",JSON.stringify(data));
        next();
      }
   
  };
  export const getRecentsearch = () => {
    if (typeof window == 'undefined') {
        return false;
    }
    if (localStorage.getItem('recentSearch')) {
        return JSON.parse(localStorage.getItem('recentSearch'));
    } else {
        return false;
    }
};
export const addRecentProducts = (data,next) => {
    /*   alert(data); */
    /* console.log(data) */
      if (typeof window !== 'undefined' ) {
          localStorage.setItem("recentProducts",JSON.stringify(data));
        next();
      }
   
  };
  export const getRecentProducts = () => {
    if (typeof window == 'undefined') {
        return false;
    }
    if (localStorage.getItem('recentProducts')) {
        return JSON.parse(localStorage.getItem('recentProducts'));
    } else {
        return false;
    }
};
export const addRecentCategories = (data,next) => {
    /*   alert(data); */
    /* console.log(data) */
      if (typeof window !== 'undefined' ) {
          localStorage.setItem("recentCategories",JSON.stringify(data));
        next();
      }
   
  };
  export const getRecentCategories = () => {
    if (typeof window == 'undefined') {
        return false;
    }
    if (localStorage.getItem('recentCategories')) {
        return JSON.parse(localStorage.getItem('recentCategories'));
    } else {
        return false;
    }
};
export const addCart = (data) => {
    /*   alert(data); */
    /* console.log(data) */
      if (typeof window !== 'undefined' ) {
          localStorage.setItem("cart",JSON.stringify(data));
      
      }
   
  };
  export const getCart = () => {
    if (typeof window == 'undefined') {
        return false;
    }
    if (localStorage.getItem('cart')) {
        return JSON.parse(localStorage.getItem('cart'));
    } else {
        return false;
    }
};

